import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    title: {
        id: '_.modal.id_now.title',
        defaultMessage: `Identity check`
    },
    descriptionTop: {
        id: '_.modal.id_now.description_top',
        defaultMessage: `Identity check description top`
    },
    descriptionBottom: {
        id: '_.modal.id_now.description_bottom',
        defaultMessage: `Identity check description bottom`
    },
    continueToIDNow: {
        id: '_.modal.id_now.continue_to_id_now',
        defaultMessage: 'Continue identity verification'
    }
});
